import type { SVGProps } from 'react'
const DeliveryBoxesIconlyProIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 40 40" {...props}>
    <g opacity={0.4}>
      <foreignObject width={36.818} height={36.335} x={11.707} y={9.974}>
        <div
          style={{
            backdropFilter: 'blur(5.64px)',
            clipPath: 'url(#Delivery_Boxes_-_Iconly_Pro_svg__a)',
            height: '100%',
            width: '100%'
          }}
        />
      </foreignObject>
      <path
        fill="url(#Delivery_Boxes_-_Iconly_Pro_svg__b)"
        fillRule="evenodd"
        d="m33.05 21.25-5.9.017c-1.168 0-2.2.4-2.95 1.166-.784.784-1.218 1.917-1.218 3.2L23 30.717c.017 2.55 1.733 4.316 4.183 4.316l5.9-.016c1.184 0 2.2-.4 2.95-1.15.784-.784 1.217-1.917 1.217-3.2l-.017-5.084c0-2.55-1.716-4.333-4.183-4.333"
        clipRule="evenodd"
        data-figma-bg-blur-radius={11.276}
      />
      <foreignObject width={36.818} height={35.902} x={11.707} y={-6.309}>
        <div
          style={{
            backdropFilter: 'blur(5.64px)',
            clipPath: 'url(#Delivery_Boxes_-_Iconly_Pro_svg__c)',
            height: '100%',
            width: '100%'
          }}
        />
      </foreignObject>
      <path
        fill="url(#Delivery_Boxes_-_Iconly_Pro_svg__d)"
        fillRule="evenodd"
        d="M24.232 17.2c.75.733 1.75 1.117 2.917 1.117h5.933c2.5-.017 4.167-1.767 4.167-4.367l-.017-4.65c0-2.55-1.716-4.333-4.183-4.333l-5.9.016c-1.167 0-2.183.4-2.95 1.167-.783.783-1.217 1.917-1.217 3.2L23 14c.017 1.283.45 2.417 1.233 3.2"
        clipRule="evenodd"
        data-figma-bg-blur-radius={11.276}
      />
    </g>
    <path
      fill="#2852E4"
      d="M28.782 27.969h2.667c.7 0 1.25-.55 1.25-1.25 0-.684-.55-1.25-1.25-1.25h-2.667a1.26 1.26 0 0 0-1.25 1.25c0 .7.567 1.25 1.25 1.25M31.449 9.183h-2.667a1.26 1.26 0 0 0-1.25 1.25c0 .7.567 1.25 1.25 1.25h2.667c.7 0 1.25-.55 1.25-1.25 0-.683-.55-1.25-1.25-1.25"
    />
    <foreignObject width={36.802} height={47.252} x={-5.693} y={-1.341}>
      <div
        style={{
          backdropFilter: 'blur(5.64px)',
          clipPath: 'url(#Delivery_Boxes_-_Iconly_Pro_svg__e)',
          height: '100%',
          width: '100%'
        }}
      />
    </foreignObject>
    <path
      fill="url(#Delivery_Boxes_-_Iconly_Pro_svg__f)"
      fillOpacity={0.3}
      fillRule="evenodd"
      d="M15.65 9.935h-5.9c-1.234.016-2.284.466-3.017 1.233-.733.784-1.15 1.85-1.15 3.134L5.6 30.318c0 1.283.433 2.417 1.216 3.2.75.733 1.767 1.117 2.917 1.117h5.95c2.45-.017 4.167-1.817 4.15-4.367v-16c0-1.283-.45-2.417-1.233-3.2-.75-.75-1.8-1.117-2.95-1.133"
      clipRule="evenodd"
      data-figma-bg-blur-radius={11.276}
    />
    <path
      fill="#2852E4"
      d="M11.366 17.168h2.684c.683 0 1.25-.55 1.25-1.25 0-.683-.567-1.25-1.25-1.25h-2.684a1.26 1.26 0 0 0-1.25 1.25c0 .7.567 1.25 1.25 1.25"
    />
    <defs>
      <linearGradient
        id="Delivery_Boxes_-_Iconly_Pro_svg__b"
        x1={24.509}
        x2={39.679}
        y1={22.522}
        y2={30.652}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5A81FF" stopOpacity={0.9} />
        <stop offset={0.447} stopColor="#567DFF" stopOpacity={0.955} />
        <stop offset={1} stopColor="#4E78FF" stopOpacity={0.9} />
      </linearGradient>
      <linearGradient
        id="Delivery_Boxes_-_Iconly_Pro_svg__d"
        x1={24.509}
        x2={39.459}
        y1={6.198}
        y2={14.471}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5A81FF" stopOpacity={0.9} />
        <stop offset={0.447} stopColor="#567DFF" stopOpacity={0.955} />
        <stop offset={1} stopColor="#4E78FF" stopOpacity={0.9} />
      </linearGradient>
      <linearGradient
        id="Delivery_Boxes_-_Iconly_Pro_svg__f"
        x1={7.108}
        x2={25.015}
        y1={12.214}
        y2={17.563}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5A81FF" stopOpacity={0.9} />
        <stop offset={0.447} stopColor="#567DFF" stopOpacity={0.955} />
        <stop offset={1} stopColor="#4E78FF" stopOpacity={0.9} />
      </linearGradient>
      <clipPath id="Delivery_Boxes_-_Iconly_Pro_svg__a">
        <path
          fillRule="evenodd"
          d="m21.343 11.276-5.9.017c-1.167 0-2.2.4-2.95 1.166-.784.784-1.217 1.917-1.217 3.2l.016 5.084c.017 2.55 1.734 4.316 4.184 4.316l5.9-.016c1.183 0 2.2-.4 2.95-1.15.783-.784 1.216-1.917 1.216-3.2l-.016-5.084c0-2.55-1.717-4.333-4.183-4.333"
          clipRule="evenodd"
        />
      </clipPath>
      <clipPath id="Delivery_Boxes_-_Iconly_Pro_svg__c">
        <path
          fillRule="evenodd"
          d="M12.526 23.51c.75.733 1.75 1.116 2.917 1.116h5.933c2.5-.017 4.166-1.767 4.166-4.367l-.016-4.65c0-2.55-1.717-4.333-4.183-4.333l-5.9.017c-1.167 0-2.184.4-2.95 1.166-.784.784-1.217 1.917-1.217 3.2l.016 4.65c.017 1.284.45 2.417 1.234 3.2"
          clipRule="evenodd"
        />
      </clipPath>
      <clipPath id="Delivery_Boxes_-_Iconly_Pro_svg__e">
        <path
          fillRule="evenodd"
          d="M21.343 11.276h-5.9c-1.234.017-2.284.467-3.017 1.233-.733.784-1.15 1.85-1.15 3.134l.017 16.016c0 1.283.433 2.417 1.216 3.2.75.733 1.767 1.117 2.917 1.117h5.95c2.45-.017 4.167-1.817 4.15-4.367v-16c0-1.283-.45-2.416-1.233-3.2-.75-.75-1.8-1.116-2.95-1.133"
          clipRule="evenodd"
        />
      </clipPath>
    </defs>
  </svg>
)
export default DeliveryBoxesIconlyProIcon
